<template>
  <div class="bec-condensate-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>λ_dB > d | 宏观量子相干态$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <rect width="400" height="240" fill="rgba(0, 4, 15, 0.4)" />
          
          <!-- Atoms / Waves -->
          <g v-for="a in atoms" :key="a.id">
             <!-- Individual wave function -->
             <circle :cx="a.x" :cy="a.y" :r="waveRadius" 
                     :fill="a.color" :opacity="waveOpacity" 
                     :filter="temp < 20 ? 'url(#glowBEC)' : 'none'" />
          </g>

          <!-- Central Condensate Glow -->
          <circle v-if="temp < 10" cx="200" cy="120" r="40" fill="rgba(255, 255, 255, 0.1)" filter="url(#glowBEC)">
             <animate attributeName="opacity" values="0.1;0.3;0.1" dur="2s" repeatCount="indefinite" />
          </circle>

          <defs>
             <filter id="glowBEC">
                <feGaussianBlur stdDeviation="4" result="blur" />
                <feComposite in="SourceGraphic" in2="blur" operator="over" />
             </filter>
          </defs>

          <text x="20" y="30" fill="#888" font-size="8">德布罗意波长 λ_dB: {{ (100/temp).toFixed(2) }}</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>系统温度: {{ temp }} nK</label>
              <div class="value" :style="{color: temp < 20 ? '#fff' : '#00d2ff'}">
                 {{ temp < 20 ? '凝聚态 (相干波)' : '自由气体态' }}
              </div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>磁阱降温</label>
             <el-slider v-model="temp" :min="1" :max="100" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>根据量子力学，当原子的温度降至接近绝对零度时，其德布罗意波长会增加到与原子间距相当。此时，所有原子开始发生波函数重叠，并集体“陷落”到最低能态（基态），形成**玻色-爱因斯坦凝聚**。在这种状态下，成千上万个原子像一个单一的“超级原子”一样协同律动，表现出宏观的量子相干性。这是研究超流性、量子干涉和精密测量的理想平台。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BECViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      temp: 80,
      atoms: [],
      timer: null
    }
  },
  computed: {
    waveRadius() {
       return 5 + (100 / this.temp);
    },
    waveOpacity() {
       return this.temp < 20 ? 0.6 : 0.3;
    }
  },
  methods: {
    initAtoms() {
       this.atoms = [];
       for (let i = 0; i < 30; i++) {
          this.atoms.push({
             id: i,
             x: Math.random() * 400,
             y: Math.random() * 240,
             vx: (Math.random() - 0.5) * 4,
             vy: (Math.random() - 0.5) * 4,
             color: '#00d2ff'
          });
       }
    },
    animate() {
       const speed = this.temp / 40;
       const focus = Math.max(0, (20 - this.temp) / 20); // Focus toward center
       
       this.atoms.forEach(a => {
          a.x += a.vx * speed + (200 - a.x) * focus * 0.05;
          a.y += a.vy * speed + (120 - a.y) * focus * 0.05;
          
          if (a.x < 0 || a.x > 400) a.vx *= -1;
          if (a.y < 0 || a.y > 240) a.vy *= -1;
       });
       this.timer = requestAnimationFrame(this.animate);
    }
  },
  mounted() { this.initAtoms(); this.animate(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.bec-condensate-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #01040f; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 255, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
